import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { CommonService } from '../../services/common.service';
import { AuthService } from '../../modules/authentication/services/auth.service';

@Component({
  selector: 'distributor-autocomplete-switch',
  templateUrl: './distributor-autocomplete-switch.component.html',
  styleUrls: ['./distributor-autocomplete-switch.component.scss'],
})
export class DistributorAutocompleteSwitchComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isReadonly: boolean = false;
  @Input() dropDownIconPosInPx?: string = '0px';
  @ViewChild('searchFilter') searchFilterHtmlElement: ElementRef<HTMLInputElement>;
  @ViewChild('searchFilter', { read: MatAutocompleteTrigger }) searchFilterTrigger: MatAutocompleteTrigger;

  vrmPrimaryColor: string;

  isSearchFilterShown: boolean = false;
  searchFilterFormControl = new UntypedFormControl();

  filteredCompanies: Observable<string[]>;
  panelCloseSubscription: Subscription;

  constructor(public cService: CommonService, public authService: AuthService) {}

  ngOnInit() {
    this.vrmPrimaryColor =
      this.cService.userProfile && this.cService.userProfile.HqColour ? '#' + this.cService.userProfile.HqColour : '';

    this.dropDownIconPosInPx = this.dropDownIconPosInPx.toString().trim().endsWith('px')
      ? this.dropDownIconPosInPx
      : this.dropDownIconPosInPx + 'px';

    if (!this.cService.userProfile.distributorCompanies || !this.cService.userProfile.distributorCompanies.length) {
      this.isReadonly = true;
    }
    this.filteredCompanies = this.searchFilterFormControl.valueChanges.pipe(
      startWith(''),
      map((companySearchText) => this._filterDistributorCompanies(companySearchText))
    );
  }

  ngAfterViewInit() {
    this.panelCloseSubscription = this.searchFilterTrigger.panelClosingActions.subscribe((e) => {
      this.hideSearchFilter();
    });
  }

  private _filterDistributorCompanies(companySearchText: string): string[] {
    let filteredCompanies = [];
    if (this.cService.userProfile.distributorCompanies) {
      filteredCompanies = this.cService.userProfile.distributorCompanies.filter((option) =>
        option.toLowerCase().includes(companySearchText.toLowerCase())
      );
    }
    return filteredCompanies;
  }

  public showSearchFilter() {
    this.isSearchFilterShown = true;
    setTimeout(() => {
      this.searchFilterHtmlElement.nativeElement.focus();
    });
  }

  public hideSearchFilter() {
    this.isSearchFilterShown = false;
    this.searchFilterFormControl.setValue('');
  }

  public companySelected(optionSelected: MatAutocompleteSelectedEvent) {
    const selectedDistributorCompany: string = optionSelected.option.value;
    this.authService.switchToSelectedCompany(selectedDistributorCompany);
    this.hideSearchFilter();
  }

  public ngOnDestroy() {
    this.panelCloseSubscription.unsubscribe();
  }
}
